<template>
<div class="content-wrapper">

    <section class="content">

        <div class="box">
            <div class="box-header with-border">
                <h1 class="box-title"><b>ads.txt</b></h1>
                <pre id="divClipboard">{{bidders}}</pre>
                        
             
            </div>
            <div>

                <div class="box">
                    <div class="box-header with-border">
                        <h1 class="box-title"><b>Please add domain specific ads.txt entries here</b></h1>
                        <div>
                            <textarea placeholder="Enter data" rows="4" cols="150" v-model="biddersData" style="border:1px solid black;padding:10px"></textarea>
                            <div><button @click="addData" type="button" class="btn btn-primary" >Submit</button></div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </section>

</div>
</template>

<script>
import axios from 'axios';

export default {

    data() {
        return {
            msg: 'charmi',
            uuid: '',
            domId: '',
            bidders: [],
            biddersData: ''
        }

    },
    created: function () {
        this.uuid = this.$route.params.uuid;
        this.domId = this.$route.params.domId;
        console.log("uuid and domid", this.uuid, this.domId);
        this.getdata();
        this.getbidderdata();
    },
    methods: {
        getbidderdata(){
            var api = BASE_URL + `v1/dynamic-bidder-data/${this.uuid}/domain/${this.domId}/`
             axios.get(api).then(res => {
                 this.biddersData = res.data.data[0].dynamic_bidders;
                console.log("res",res);
            })
        },
        getdata() {
            var api = BASE_URL + `v1/ads-txt-publisher/${this.uuid}/domain/${this.domId}/`;
           
            axios.get(api).then(res => {
             
                this.bidders = res.data.data;

            })
         
        },
        addData() {
            var api = BASE_URL + `v1/ads-txt-publisher/${this.uuid}/domain/${this.domId}/`;
            let x = {
                biddersData: this.biddersData
            }
            axios.post(api, x)
                .then(res => {
                    console.log("res", res);
                    this.getdata();
                })
        }
    }
}
</script>



// WEBPACK FOOTER //
// AdsText.vue?01f71b32